<template>
	<div>
		<div class="margin-bottom-10" v-if="type == 'query'">{{$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'})}}:{{orderId}}/{{orderNumber}} {{$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'})}}：{{filterState(orderState)}}</div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery v-if="type=='query'" class="margin-top-15" :formdata="getBase" :value="formData.baseInfo" :labelWidth="180"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="editbase" :formdata="getBase" v-model="formData.baseInfo" :labelWidth="180" />
			<template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit(0)">{{$t('global.common.save',{defaultValue:'保存'})}}</vButton>
				<vButton class="margin-right-20" theme="primary" @click="submit(1)">{{$t('erp.b2border.save_yuncang',{defaultValue:'保存并推送云仓'})}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.operate_cancel',{defaultValue:'取消'})}}</vButton>
			</template>
		</compWrapper>

		<compWrapper :title="$t('erp.b2border.customer_information',{defaultValue:'客户信息'})" theme="primary">
			<compCustomer ref="compcus" :cusdata="customerInfo" :alltype="type" @on-salesId="getSalesId"></compCustomer>
		</compWrapper>

        <compWrapper :title="$t('erp.b2c.logistics_information',{defaultValue:'仓库物流信息'})" theme="primary">
            <compFormQuery v-if="type=='query'" class="margin-top-15" :formdata="getWarehouse" :value="formData.warehouseInfo" :labelWidth="180"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="editwatrhouse" :formdata="getWarehouse" v-model="formData.warehouseInfo" :labelWidth="180" />
		</compWrapper>

        <compWrapper :title="$t('erp.b2c.product_information',{defaultValue:'产品信息'})" theme="primary">
			<compProduct ref="compprod" :productdata="productInfos" :alltype="type" :warehouseid="warehouseid" @on-listcost="getAmount"></compProduct>
		</compWrapper>

        <compWrapper :title="$t('erp.b2border.sales_information',{defaultValue:'销售信息'})" theme="primary">
            <compFormQuery v-if="type=='query'" class="margin-top-15" :formdata="getSales" :value="saleInfo" :labelWidth="180"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" ref="editsales" :formdata="getSales" v-model="saleInfo" :labelWidth="180" />
		</compWrapper>

        <compWrapper v-if="this.formList.length>0 && type=='query'" :title="$t('erp.b2c.parcel_information',{defaultValue:'包裹信息'})" theme="primary">
            <vTable
            class="margin-15"
            :columns="columns"
            :data="formList"
            size="small"
            ref="tablequery"
            border ></vTable>
		</compWrapper>

        <compWrapper :title="$t('erp.b2border.notes_information',{defaultValue:'备注信息'})" theme="primary">
            <compFormQuery v-if="type=='query'" :formdata="getNotes" :value="formData" :labelWidth="180"></compFormQuery>
			<compFormEdit v-else class="margin-15 clearfix" :formdata="getNotes" v-model="formData" :labelWidth="180" />
		</compWrapper>

		<compWrapper :title="$t('global.log.name',{defaultValue:'操作历史'})" theme="gray" v-if="query">
			<compLog class="margin-15" :data="opLogList"></compLog>
		</compWrapper>

		<!-- <div class="text-right padding-right-20" v-show="type!='query'">
			<vButton theme="primary" @click="submit">确定</vButton>
			<vButton class="margin-left-10" @click="cancel">取消</vButton>
		</div> -->
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { HttpGetOne,HttpSaveOne } from "@/service/boss/b2border";
import { HttpFindWarehouseCarriers } from '@/service/boss/b2corder'
import { HttpAllLogs } from "@/service/managechannel/managechannel";
import compCustomer from './customer'
import compProduct from './product'
export default {
	props:['activeids','querytype'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        // compLog: () => import("./log"),
        compCustomer,
        compProduct
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			channelAccountList: [],
			opLogList: [],
			formData: {
				baseInfo:{},
				warehouseInfo:{
					checkInventory:1,
                    carrierServiceCode:2,
				},
			},
			customerInfo:{},
			productInfos:{},
			saleInfo:{
				salespersonId:'',
				amount:0,
				paymentTerm:'30',
				paymentMethod:10,
				commissionRate:0,
			},
			products: [],
            loading: false,
			formList:[],
			shippingList:[],
			orderId:'',
			orderNumber:'',
			orderState:'',
			warehouseid:null,
		}
	},
	created() {
		this.getDetail()

		// this.HttpGetContry()
	},
	computed: {
        ...mapGetters('diction',['getAllCurrency','getAllSalesList']),
        ...mapGetters('dictionary', ['getNewAllWarehouseIdList']),
        orgWarehouseAll(){
			let _this = this
            return this.getNewAllWarehouseIdList.filter(function(item){
                return item.attach.warehouseType != 4 && item.attach.orgId == global.SYSID
            })
		},

		getBase(){
			return [
				{
					label: this.$t('erp.b2border.settle_currency',{defaultValue:'结算币种'}),
					key: "currency",
					tag: 'vSelect',
					options: this.getAllCurrency,
					props: {
						filterable: true,
					}
				},
				{
					label: this.$t('erp.b2border.refNo',{defaultValue:'参考号'}),
					key: "refNo",
					required:false,
					query:this.type != 'add',
					formItem: {
                        tip: this.type == 'add' ? "<span style='color: red'>"+this.$t('erp.b2border.refno_tip',{defaultValue:'请填写内部识别号,此信息必须在仓库实际收货凭证显示（Shipping label/BOL），否则仓库接受数据无法完成对应订单'})+"</span>" : '',
                    }
				},
				{
					label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
					show:this.type == 'query',
					key: "invoiceNo",
					tag:'a',
					on:{
						'on-click':function(){
							// console.log(343434343)
						}
					},
				},
			]
		},
		getWarehouse() {
			return [
				{
					label: this.$t('erp.b2c.search_outwarehouse',{defaultValue:'发货仓库'}),
					key: "orgWarehouseCode",
					tag: 'vSelect',
					options:this.orgWarehouseAll.map(function(item){
						return {
							value:item.attach.code,
							label:item.label
						}
					}),
					on:{
						'on-change':(val)=>{
							this.getwarehouseCarry(val)
						}
					}
				},

				{
					label: this.$t('erp.b2c.shipping_method',{defaultValue:'发货方式'}),
					key: "carrierServiceCode",
					tag:"vRadio",
                    required: false,
                    valueText: this.formData.warehouseInfo.carrierServiceCode==2?this.$t('erp.b2border.warehouse_arrange',{defaultValue:'仓库安排'}):this.$t('erp.b2border.customer_arrange',{defaultValue:'客户安排'}),
                    props: {
                        strict: false,
                    },
                    options: [{
                        trueValue: 2,
                        label: this.$t('erp.b2border.warehouse_arrange',{defaultValue:'仓库安排'})
                    }, {
                        trueValue: 1,
                        label: this.$t('erp.b2border.customer_arrange',{defaultValue:'客户安排'})
                    }],
                    formItem:{
                        labelWidth:this.styWidth,
                    }

				},
				{
                    label:this.$t('erp.b2border.checkInventory',{defaultValue:'是否验证库存'}),
                    key: "checkInventory",
                    tag:"vRadio",
                    required: false,
                    valueText: this.formData.warehouseInfo.checkInventory==1?this.$t('erp.global.yes',{defaultValue:'是'}):this.$t('erp.global.no',{defaultValue:'否'}),
                    props: {
                        strict: false,
                    },
                    options: [{
                        trueValue: 1,
                        label: this.$t('erp.global.yes',{defaultValue:'是'})
                    }, {
                        trueValue: 0,
                        label: this.$t('erp.b2border.no_tip',{defaultValue:'否（不需要推送仓库发货的可以选“否”）'})
                    }],
                    formItem: {
                        labelWidth:this.styWidth,
                        style:"margin-bottom:30px",
                        //tip:"<span style=\"color: red\">（不需要推送仓库发货的可以选“否”）</span>"
                    }
                },
			];
        },
        getSales(){
            return [
                {
					label: this.$t('erp.b2border.salesman',{defaultValue:'销售员姓名'}),
					key: "salespersonId",
					tag:'vSelect',
                    options:this.getAllSalesList,
					props: {
						filterable: true,
					}
                },
                {
					label: this.$t('erp.b2border.inpaymentType',{defaultValue:'收款类型'}),
					key: "paymentMethod",
					tag: "vSelect",
					options: [
						{value:10,label:this.$t('erp.b2border.check',{defaultValue:'支票'})},
						{value:20,label:this.$t('erp.b2border.remittance',{defaultValue:'汇款'})},
					],
					props: {
						filterable: true,
					},
					required:false,
                },
                {
					label: this.$t('erp.b2border.percentage',{defaultValue:'佣金百分比(%)'}),
					key: "commissionRate",
                },
                {
					label: this.$t('erp.b2border.allcount',{defaultValue:'总金额'}),
					key: "amount",
					required:false,
					query:true,
                },
                {
					label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
					key: "paymentTerm",
					tag: "vSelect",
					options:[
                        {value:'30',label:'30NET'},
                        {value:'60',label:'60NET'},
                        {value:'90',label:'90NET'},
                    ],
					props: {
						filterable: true,
					},
					required:false,
                },
                {
					label: this.$t('erp.b2c.freight',{defaultValue:'运费'}),
					key: "shippingFee",
					required:false,
				},

            ]
        },
        getNotes(){
            return [
                {
					label: this.$t('global.common.notes',{defaultValue:'备注'}),
                    key: "remark",
					tag:'vTextarea',
					required:false,
                },
            ]
        },
        columns(){
            return [
                {
                    title: "Tracking",
					key:'trackingNo',
					width:100,
                },
                {
                    title: "Carrier",
                    key:'carrierServiceCode',
                },
                {
                    title: "ERP SKU",
                    key:'erpSku',
                },
                {
                    title: this.$t('erp.b2c.quantity_shipped',{defaultValue:'发货数量'}),
                    key:'qty',
                },
                {
                    title: this.$t('erp.b2c.search_outtime',{defaultValue:'发货时间'}),
                    key:'shipmentDate',
                },
            ]
        },
	},
	methods: {
		filterState(val){ 
			switch(val){
				case 'pending': return this.$t('fbb.inbound.draft',{defaultValue:'草稿'}); break;
				case 'assigned': return this.$t('global.common.confirmed',{defaultValue:'已确认'}); break;
				case 'picked': return this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'}); break;
				case 'shipped': return this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'}); break;
				case 'completed': return this.$t('global.upload.complete',{defaultValue:'已完成'}); break;
				case 'canceled': return this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'}); break;
			}
			// return state
		},
		// 获取金额
		getAmount(datalist){
			// console.log(datalist)
			let number = 0;
			datalist.map(item=>{
				number += Number(item.amount)
			})
			// console.log(number)
			this.saleInfo.amount = number
			this.$set(this.saleInfo,'amount',number)
		},
        getSalesId(salesid){
			// console.log(salesid)
			this.saleInfo.salespersonId = salesid
			// console.log(this.formData.saleInfo.salespersonId)
			this.$set(this.saleInfo,'salespersonId',salesid)
		},
		getDetail() {
			if(this.type =='add') return
			// console.log(this.activeids)
			if(this.activeids){
                this.id = this.activeids
                this.type = this.querytype
            }else{
                this.id = this.id
                this.type = this.type
			}
			// console.log(this.id)
			this.loading = true;
			HttpGetOne({
				orderId: this.id
			}).then(
				res => {
					this.handleResponse(res.data);
				},
				err => {
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			).finally(res => {
				this.loading = false
			})
		},
		getwarehouseCarry(val){
			// warehouseid
			let itemone = this.orgWarehouseAll.filter(item=>{
				if(item.attach.code === val){
					return item
				}
			})
			// console.log(itemone)
			this.warehouseid = itemone[0].value
			HttpFindWarehouseCarriers({
                    warehouseCode:val,
                    contextId:global.SYSID,
                    orderType:200
            }).then(res=>{
                this.shippingList = res.data
                // console.log(res)
            },err=>{
                this.errorMessage(err.message);
            })
		},
		handleResponse(data = {}) {
			this.formData = data
			this.customerInfo = data.customerInfo
			this.productInfos = data.productInfos
			this.saleInfo = data.saleInfo

			this.formList = data.packageInfos
			this.orderId = data.baseInfo.id
			this.orderNumber = data.baseInfo.orderNo
			this.orderState = data.baseInfo.orderStatus
			this.opLogList = data.b2cOrderLogItems
			//this.formData.warehouseInfo.checkInventory = 1
			// console.log(data)
		},
		async submit(savetype) {
			let bool1 = await this.$refs.editbase.validate()
			if (!bool1) return

			// 客户信息的必填
			let bool4 = await this.$refs.compcus.validate();
			if (!bool4) return;


			let bool2 = await this.$refs.editwatrhouse.validate()
			if (!bool2) return

			let bool3 = await this.$refs.editsales.validate()
			if (!bool3) return

			let compcustomer = this.$refs.compcus
			let compproduct = this.$refs.compprod

			let flag,numflag;
			if(compproduct.formList.length<1){
				this.$VMessage.error(this.$t('erp.b2border.product_empty',{defaultValue:'产品信息不能为空'}));
				return;
			}else{
				// 判断是否里面必填都写了
				compproduct.formList.find(item=>{
					if(item.erpSku == ''){
						flag = true
					}
					if(item.qty == '0' || item.unitPrice == '0'){
						numflag = true
					}
				})
				if(flag){
                    this.$Message.error(this.$t('erp.b2border.product_erpsku_empty',{defaultValue:'产品信息erpsku不能为空'}));
                    return;
				}
				if(numflag){
                    this.$Message.error(this.$t('erp.b2border.product_qty_empty',{defaultValue:'产品信息数量与单价必须大于0'}));
                    return;
				}

			}

			// console.log(compcustomer)
			// console.log(compproduct)

			let cusdata = {
				customerId:compcustomer.formData.customerId,
				shipTo:compcustomer.formData.id,
				billTo:compcustomer.formData.billid
			}
			this.formData.saleInfo = this.saleInfo
			this.formData.customerInfo = cusdata
			this.formData.productInfos = compproduct.formList
			this.formData.saveFlag = 0
			// console.log(this.formData)
			HttpSaveOne({
				...this.formData,
				saveFlag:savetype,
			}).then(res=>{
				this.$VMessage.success(res.message)
				this.cancel()
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		cancel() {
			this.$router.push({
				name: 'b2bOrder',
			});
		}
	},
	
}
</script>
